import React, { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import './LoginPage.css'; // We'll create this for styling

const LoginPage = () => {
  const { loginWithRedirect } = useAuth0();

  useEffect(() => {
    loginWithRedirect();
  }, [loginWithRedirect]);

  return null; // Optionally, you can return a loading spinner here
};

export default LoginPage;
